import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { LanguageProvider } from "./context/LanguageContext";
import LandingPage from "./pages/LandingPage";
import AboutPage from "./pages/AboutPage";
import DirectorPage from "./pages/DirectorPage";
import BookAppointment from "./pages/BookAppointment";
import ServiceDetailPage from "./pages/ServiceDetailPage";
import TeamPage from "./pages/TeamPage";
import TeamDeptPage from "./pages/TeamDeptPage";
import FacilityDetailPage from "./pages/FacilityDetailPage";
import "./styles/modern-design.css";

function App() {
  return (
    <LanguageProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/director-message" element={<DirectorPage />} />
          <Route path="/book" element={<BookAppointment />} />
          <Route path="/services/:serviceKey" element={<ServiceDetailPage />} />
          <Route path="/team" element={<TeamPage />} />
          <Route path="/team/:deptKey" element={<TeamDeptPage />} />
          <Route path="/facilities/:facilityKey" element={<FacilityDetailPage />} />
        </Routes>
      </BrowserRouter>
    </LanguageProvider>
  );
}

export default App;
